import { createActionGroup, props } from '@ngrx/store';

export const FeatureFlagsActions = createActionGroup({
  source: 'FeatureFlags',
  events: {
    'Load Active Features': props<{ dataSpaceId?: number }>(),
    'Load Active Features Success': props<{
      activeFeatures: string[];
      dataSpaceId: number | null;
    }>(),
    'Load Active Features Failure': props<{ error: string }>()
  }
});
